import React, { useState } from 'react';
import PDF from '../../assets/pdfs/Whitepaper-KittyNFT.pdf';
import { HashLink } from 'react-router-hash-link';
import { Link } from 'react-scroll';

import './CustomNav.css';
import Social from './Social';
import { CloseButton } from 'react-bootstrap';

const CustomNav = ({ menuHandler }) => {
  return (
    <div>
      <div className='nav__div' onClick={menuHandler}>
        <div className='div__body'>
          <div className='div__header'>
            <CloseButton className='btn-close' onClick={menuHandler} />

            <h2 className='side__h2'> Kutee Kitty NFT</h2>
          </div>

          <div className='offcanvas--menu side-link'>
            <Link
              to='our-mission'
              smooth={true}
              className='p-3 border-bottom border-dark text-decoration-none'
              onClick={menuHandler}
            >
              Our Mission
            </Link>
            <Link
              to='gallery'
              smooth={true}
              className='p-3 border-bottom border-dark text-decoration-none'
              onClick={menuHandler}
            >
              Gallery
            </Link>
            <Link
              to='roadmap'
              smooth={true}
              className='p-3 border-bottom border-dark text-decoration-none'
              onClick={menuHandler}
            >
              Roadmap
            </Link>
            <Link
              to='utilities'
              smooth={true}
              className='p-3 border-bottom border-dark text-decoration-none'
            >
              Utilities
            </Link>
            {/* <Link
              to='contest'
              smooth={true}
              className='p-3 border-bottom border-dark text-decoration-none'
              onClick={menuHandler}
            >
              Contest
            </Link> */}
            <Link
              to='our-team'
              smooth={true}
              className='p-3 border-bottom border-dark text-decoration-none'
              onClick={menuHandler}
            >
              Our Team
            </Link>
            <Link
              to='faq'
              smooth={true}
              className='p-3 border-bottom border-dark text-decoration-none'
              onClick={menuHandler}
            >
              Faqs
            </Link>
            <Link
              to='contact'
              smooth={true}
              className='p-3 border-bottom border-dark text-decoration-none'
              onClick={menuHandler}
            >
              Contact Us
            </Link>
            <HashLink
              to={PDF}
              smooth={true}
              className='p-3 border-bottom border-dark text-decoration-none'
              target='_blank'
              onClick={menuHandler}
            >
              Whitepaper
            </HashLink>
          </div>
          <Social />
        </div>
      </div>
    </div>
  );
};

export default CustomNav;
